import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import isNil from 'lodash/isNil'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import humps from 'humps'
import api from '../../api'
import { useAsync } from '../../hooks'
import { PageHeader } from '../Common'
import Loading from '../Loading'
import PracticeForm, { NON_FILE_PRACTICE_FIELDS } from './PracticeForm'

export default function EditPractice() {
  const navigate = useNavigate()
  const { id } = useParams()
  const getPractice = useCallback(
    () =>
      api.practices.getPractice(id).then(practice => ({
          ...practice,
          logo: practice.logoPath,
          ownerEmails: practice.ownerEmails.join('\n'),
          bpAlertRecipients: practice.bpAlertRecipients.join('\n'),
        })),
    [id],
  )
  const { pending, value } = useAsync(getPractice)

  const onSubmit = useCallback(
    async (practiceValues, { setErrors }) => {
      try {
        const fd = new FormData()

        NON_FILE_PRACTICE_FIELDS.forEach(field => {
          if (!isNil(practiceValues[field])) {
            fd.append(humps.decamelize(field), practiceValues[field])
          }
        })

        if (Array.isArray(practiceValues.logo)) {
          fd.append('logo', practiceValues.logo[0])
        }

        await api.practices.updatePractice(id, fd)
        message.success('Practice successfully updated')
        navigate(-1)
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, fieldErrors => fieldErrors[0]))
        } else {
          message.error('Oops, we had a problem. Please try submitting again')
        }
      }
    },
    [navigate, id],
  )

  if (pending) return <Loading large />

  return (
    <div>
      <PageHeader title="Edit Practice" onBack={() => navigate(-1)} />
      <PracticeForm practiceData={value} onSubmit={onSubmit} />
    </div>
  )
}
